(function () {
  if (window.TabbedCollectionsInitialized) return;
  window.TabbedCollectionsInitialized = true;

  var MOBILE_BREAKPOINT = 750;

  function isMobile() {
    return window.innerWidth < MOBILE_BREAKPOINT;
  }

  function initGrid(grid) {
    if (grid.dataset.tabbedInited) return;
    grid.dataset.tabbedInited = '1';

    var sectionId = grid.dataset.sectionId;
    var viewMoreBtn = document.getElementById('ViewMore-' + sectionId);
    var viewMoreContainer = document.getElementById('ViewMoreContainer-' + sectionId);

    var totalProducts = parseInt(grid.dataset.totalProducts);
    var viewAllUrl = grid.dataset.viewAllUrl;
    var loadBehavior = grid.dataset.loadBehavior;
    var initialDesktop = parseInt(grid.dataset.initialDesktop);
    var initialMobile = parseInt(grid.dataset.initialMobile);
    var perLoadDesktop = parseInt(grid.dataset.productsPerLoadDesktop);
    var perLoadMobile = parseInt(grid.dataset.productsPerLoadMobile);

    var allItems = Array.from(grid.querySelectorAll('.grid__item'));
    var productsVisible = 0;
    var wasMobile = isMobile();

    function getInitial() {
      return isMobile() ? initialMobile : initialDesktop;
    }

    function getPerLoad() {
      return isMobile() ? perLoadMobile : perLoadDesktop;
    }

    function showItems(targetCount) {
      var end = Math.min(targetCount, allItems.length, totalProducts);
      for (var i = productsVisible; i < end; i++) {
        allItems[i].classList.remove('hidden');
      }
      productsVisible = end;
      updateButton();
    }

    function updateButton() {
      if (!viewMoreBtn || !viewMoreContainer) return;
      if (productsVisible >= totalProducts || productsVisible >= allItems.length) {
        viewMoreBtn.textContent = 'View All';
        viewMoreBtn.onclick = function () { window.location.href = viewAllUrl; };
        viewMoreContainer.classList.remove('hidden');
      } else if (loadBehavior === 'click') {
        viewMoreBtn.textContent = 'View More';
        viewMoreBtn.onclick = function () { showItems(productsVisible + getPerLoad()); };
        viewMoreContainer.classList.remove('hidden');
      } else {
        viewMoreContainer.classList.add('hidden');
      }
    }

    function attachScrollListener() {
      if (loadBehavior !== 'scroll') return;
      var ticking = false;
      window.addEventListener('scroll', function () {
        if (ticking || productsVisible >= totalProducts) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          var lastVisible = allItems[productsVisible - 1];
          if (!lastVisible) return;
          if (lastVisible.getBoundingClientRect().bottom - window.innerHeight < 200) {
            showItems(productsVisible + getPerLoad());
          }
        });
      }, { passive: true });
    }

    function reset() {
      allItems.forEach(function (el) { el.classList.add('hidden'); });
      productsVisible = 0;
      showItems(getInitial());
    }

    window.addEventListener('resize', function () {
      var nowMobile = isMobile();
      if (nowMobile === wasMobile) return;
      wasMobile = nowMobile;
      reset();
    }, { passive: true });

    productsVisible = 0;
    allItems.forEach(function (el) {
      if (!el.classList.contains('hidden')) productsVisible++;
    });
    if (productsVisible === 0) {
      showItems(getInitial());
    } else {
      var initial = getInitial();
      if (productsVisible > initial) {
        for (var i = initial; i < productsVisible; i++) {
          allItems[i].classList.add('hidden');
        }
        productsVisible = initial;
      }
      updateButton();
    }
    attachScrollListener();
  }

  function initSection(sectionEl) {
    var buttons = Array.from(sectionEl.querySelectorAll('.tabbed-tab-button'));
    var panels = Array.from(sectionEl.querySelectorAll('.tabbed-panel'));

    if (!buttons.length || !panels.length) return;

    var activePanel = panels.find(function (p) { return p.classList.contains('active'); });
    if (activePanel) {
      var activeGrid = activePanel.querySelector('.tabbed-collection-grid');
      if (activeGrid) initGrid(activeGrid);
    }

    function activateTab(panelId) {
      buttons.forEach(function (b) {
        var isTarget = b.getAttribute('aria-controls') === panelId;
        b.classList.toggle('active', isTarget);
        b.setAttribute('aria-selected', isTarget ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
        if (panel.id === panelId) {
          panel.classList.remove('active');
          void panel.offsetWidth;
          panel.classList.add('active');
          var grid = panel.querySelector('.tabbed-collection-grid');
          if (grid) initGrid(grid);
        } else {
          panel.classList.remove('active');
        }
      });

      var header = document.querySelector('sticky-header') || document.querySelector('#shopify-section-header');
      var headerH = header ? header.getBoundingClientRect().height : 0;
      var sectionAbsTop = sectionEl.getBoundingClientRect().top + window.scrollY;
      var scrollTarget = sectionAbsTop - headerH;
      if (window.scrollY > scrollTarget) {
        window.scrollTo({ top: scrollTarget, behavior: 'smooth' });
      }
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panelId = btn.getAttribute('aria-controls');
        if (panelId) activateTab(panelId);
      });
    });

    sectionEl.addEventListener('shopify:block:select', function (e) {
      var panelId = e.target && e.target.getAttribute('aria-controls');
      if (!panelId) {
        var tabId = e.target && e.target.dataset.tab;
        if (tabId) {
          var btn = sectionEl.querySelector('[data-tab="' + tabId + '"]');
          if (btn) panelId = btn.getAttribute('aria-controls');
        }
      }
      if (panelId) activateTab(panelId);
    });
  }

  function initAll() {
    document.querySelectorAll('[id^="tabbed-collections-"]').forEach(function (el) {
      initSection(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target && e.target.querySelector('[id^="tabbed-collections-"]');
    if (el) initSection(el);
  });
})();